// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplatesFolder = getTemplatesFolder;
exports.getResourceFolder = getResourceFolder;
const tslib_1 = require("tslib");
const path = tslib_1.__importStar(require("path"));
function getTemplatesFolder() {
    return path.resolve(__dirname, "../templates");
}
function getResourceFolder() {
    return path.resolve(__dirname, "../resource");
}
//# sourceMappingURL=folder.js.map